import Vue from 'vue'
import grid from './grid/index.vue'
import edit from './edit/index.vue'
import select from './select.vue'

Vue.component('app-tabeladesconto-grid', grid)
Vue.component('app-tabeladesconto-edit', edit)
Vue.component('app-tabeladesconto-select', select)
